// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"fb3a7f22","453":"34b55c4e","947":"59495020"}[chunkId] + ".chunk.js";
};